export default __webpack_public_path__ + "static/icons-c42d8a2af50ceb514093465af09a8089.svg";